class URLManager {
    static getBaseURL() {
        // 1) Prefer env var when available
        const envUrl = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL)
            ? String(process.env.REACT_APP_API_URL).trim()
            : '';
        if (envUrl) {
            return envUrl.endsWith('/') ? envUrl.slice(0, -1) : envUrl;
        }

        // 2) Fallback to manual environment selection
        const environment = 'production'; // 'production' ou 'local'
        if (environment === 'local') {
            return 'http://localhost:8080';
        } else if (environment === 'production') {
            return 'https://gerenciamento-stepwise-beta-1-2.onrender.com';
        }
        throw new Error('Ambiente não configurado');
    }
}

export default URLManager;